import SettingsComponent from "../../components/shared/SettingsComponent"
import { AdminSidebarLayout } from "../../components/AdminSidebar"

const Settings = () => {
    return (
        <AdminSidebarLayout currentPath="/settings">
            <SettingsComponent />
        </AdminSidebarLayout>
    )
}

export default Settings
